import { useCallback } from 'react'

const DRAFT_KEY = 'martyrForm:draft'
const META_KEY  = 'martyrForm:draft:meta'

export function useDraft() {
  const saveDraft = useCallback((formData, currentStep) => {
    try {
      // Never save file-related fields — files stay in memory only
      const safe = { ...formData }
      localStorage.setItem(DRAFT_KEY, JSON.stringify(safe))
      localStorage.setItem(META_KEY, JSON.stringify({ step: currentStep, savedAt: new Date().toISOString() }))
      return true
    } catch (e) {
      console.warn('Draft save failed:', e)
      return false
    }
  }, [])

  const loadDraft = useCallback(() => {
    try {
      const raw = localStorage.getItem(DRAFT_KEY)
      const meta = localStorage.getItem(META_KEY)
      if (!raw) return null
      return {
        formData: JSON.parse(raw),
        step: meta ? JSON.parse(meta).step : 1,
        savedAt: meta ? JSON.parse(meta).savedAt : null,
      }
    } catch {
      return null
    }
  }, [])

  const deleteDraft = useCallback(() => {
    localStorage.removeItem(DRAFT_KEY)
    localStorage.removeItem(META_KEY)
  }, [])

  const hasDraft = useCallback(() => {
    return Boolean(localStorage.getItem(DRAFT_KEY))
  }, [])

  const getDraftMeta = useCallback(() => {
    try {
      const meta = localStorage.getItem(META_KEY)
      return meta ? JSON.parse(meta) : null
    } catch {
      return null
    }
  }, [])

  return { saveDraft, loadDraft, deleteDraft, hasDraft, getDraftMeta }
}
